/* eslint-disable camelcase */
import { SORT_ORDER, TFilterOptions } from '@evinced-private/ui-common';

import omit from 'lodash-es/omit';
import { CUSTOM_FIELDS_FILTER_PARAM_KEY } from 'src/apps/dashboard/constants/CustomFields';
import {
	MOBILE_APP_ID_FILTER_ID,
	MOBILE_PLATFORM_FILTER_ID
} from 'src/apps/dashboard/constants/MobileDashboard.constants';
import { IGetMobileSdkTestsParams } from 'src/apps/dashboard/types/MobileDashboardServiceTypes';
import { IFilterOptions } from 'src/common/helpers/DataFilterHelper';
import { QueryVariablesBuilder } from 'src/common/helpers/GQLRequestsHelper/QueryVariablesBuilder';
import {
	ConditionOperators,
	Msdk_Report_RunsSortFields,
	Msdk_Report_RunsSortOrder
} from 'src/common/types/graphql.generated';

import { MobileDashboardMobileSdkTestsQueryVariables } from '../MobileSdkTests.generated';

import { buildMobileRunFilters } from './mobileFilterVariableBuilder';

const DAYS_AMOUNT_FILTER_PARAM_KEY = 'daysAmountFilter';
const MOBILE_TEST_FILTER_KEYS = ['dateRange', MOBILE_PLATFORM_FILTER_ID, MOBILE_APP_ID_FILTER_ID];

const mobileSdkTestsSortFieldNamesMap: Record<string, Msdk_Report_RunsSortFields> = {
	name: Msdk_Report_RunsSortFields.TestName,
	testName: Msdk_Report_RunsSortFields.TestName,
	date: Msdk_Report_RunsSortFields.RunTime,
	runTime: Msdk_Report_RunsSortFields.RunTime,
	criticalIssues: Msdk_Report_RunsSortFields.CriticalIssues,
	totalIssues: Msdk_Report_RunsSortFields.TotalIssues
};

const mobileSdkTestsSortOrderMap: Record<SORT_ORDER, Msdk_Report_RunsSortOrder> = {
	[SORT_ORDER.ASC]: Msdk_Report_RunsSortOrder.Ascending,
	[SORT_ORDER.DESC]: Msdk_Report_RunsSortOrder.Descending
};

export const buildMobileSdkTestsVariables = ({
	dateRange,
	pageSize,
	page,
	filterOptions,
	sort,
	labelsExcludedFromDashboard
}: IGetMobileSdkTestsParams): MobileDashboardMobileSdkTestsQueryVariables => {
	const variablesBuilder = new QueryVariablesBuilder<MobileDashboardMobileSdkTestsQueryVariables>({
		sortFieldsMap: mobileSdkTestsSortFieldNamesMap,
		sortOrderMap: mobileSdkTestsSortOrderMap
	});

	variablesBuilder.addPaginationParams(page, pageSize).addSortParam(sort);

	const customFieldOptions = omit(filterOptions ?? {}, MOBILE_TEST_FILTER_KEYS) as TFilterOptions;

	variablesBuilder.addTupleFilterParam(
		CUSTOM_FIELDS_FILTER_PARAM_KEY,
		customFieldOptions,
		ConditionOperators.All,
		true
	);

	variablesBuilder.addConditionParam(DAYS_AMOUNT_FILTER_PARAM_KEY, dateRange);

	if (labelsExcludedFromDashboard && Object.keys(labelsExcludedFromDashboard).length > 0) {
		variablesBuilder.addNeTupleFilterParam(
			'customFieldsFilterExcludes' as keyof MobileDashboardMobileSdkTestsQueryVariables,
			labelsExcludedFromDashboard
		);
	}

	const mobileRunFilters = buildMobileRunFilters(filterOptions as IFilterOptions);

	return {
		...variablesBuilder.getVariables(),
		...mobileRunFilters
	};
};
